<template>
    <storefront-node :storefront-prefix="storefrontPrefix" />
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { definePageMeta } from '#imports'
import StorefrontNode from '~/components/Storefront/StorefrontNode.vue'

definePageMeta({
    layout: 'embed'
})

const storefrontPrefix = inject('STOREFRONT_PREFIX')
</script>
